export default __webpack_public_path__ + "static/media/arrowRight.e2ba5e01.svg";